import { useContext } from 'react';
import { Field, Panel } from '../../../../layouts';
import { formatShortDate } from '../../../../utils/date-utils';
import { PurchaseOrderContext } from '../context/PurchaseOrderContext';

export default function PurchaseOrderDatesPanel() {

	const { order } = useContext(PurchaseOrderContext);

	return (
		<Panel header={'Dates'}>
			{
				order.details.deliveryFlow ?
					<>
						<Field label={'Requested Delivery Date'} >
							{formatShortDate(order.details.requestedDeliveryDate)}
						</Field>
						<Field label={'Validated Delivery Date'} >
							{formatShortDate(order.details.validatedDeliveryDate)}
						</Field>
						<Field label="Verified Delivery Date" >
							{formatShortDate(order.details.deliveredDate)}
						</Field>
					</>
					:
					<>
						<Field label={'Requested Ship Date'} >
							{formatShortDate(order.details.requestedShipDate)}
						</Field>
						<Field label={'Validate Ship Date'} >
							{formatShortDate(order.details.validatedShipDate)}
						</Field>
						<Field label="Actual Ship Date" >
							{formatShortDate(order.details.actualShipDate)}
						</Field>
					</>
			}
		</Panel>
	);
}
